var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmptyView',{attrs:{"name":_vm.t('spreed', 'Duplicate session'),"description":_vm.t('spreed', 'You joined the conversation in another window or device. This is currently not supported by Nextcloud Talk so this session was closed.')},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconInformationOutline')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }